<template>
	<div class="container" id="FeelingsLog">
		<div class="text-center gold mt-4">
			<h3>
				Dreams Log:
				<router-link :to="'/dashboard/' + this.$store.state.profile_active.id" class="">
					<small v-text="this.$store.state.profile_active.user_name"></small>
				</router-link>
			</h3>
		</div>

		<div class="row">
			<div class="offset-md-2 col-md-8">
				<dreams-log :userid="parseInt(this.$route.params.user_id)" :limit="200" />
			</div>
		</div>
	</div>
</template>

<script>
import DreamsLog from '../components/DreamsLog.vue';

export default {
	name: 'Dreams',
	components: {
		DreamsLog,
	},

	data() {
		return {};
	},

	methods: {},

	mounted() {},

	computed: {},
	watch: {},
};
</script>

<style scoped></style>
